<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 25 24" fill="none">
    <path d="M10.6897 20.1361C6.95793 19.3093 4.16699 15.9806 4.16699 12C4.16699 10.4816 4.57311 9.05797 5.28264 7.83194L8.8519 14.0141C9.56196 15.2976 10.9297 16.1667 12.5003 16.1667C12.6689 16.1667 12.8352 16.1567 12.9985 16.1372L10.6897 20.1361ZM12.5003 20.3333L16.0727 14.1459C16.45 13.5191 16.667 12.7849 16.667 12C16.667 11.062 16.3571 10.1964 15.834 9.49999H20.4522C20.7 10.2892 20.8337 11.129 20.8337 12C20.8337 16.6023 17.1027 20.3333 12.5003 20.3333ZM14.6437 13.2875C14.2064 14.014 13.4101 14.5 12.5003 14.5C11.5751 14.5 10.7672 13.9973 10.3349 13.2502L10.3113 13.2084C10.1131 12.8502 10.0003 12.4383 10.0003 12C10.0003 10.6192 11.1196 9.49999 12.5003 9.49999C13.8811 9.49999 15.0003 10.6192 15.0003 12C15.0003 12.4554 14.8786 12.8824 14.6657 13.2502L14.6437 13.2875ZM6.36049 6.36548C7.88373 4.70651 10.0706 3.66666 12.5003 3.66666C15.5848 3.66666 18.2779 5.34248 19.7188 7.83332H12.5003C10.7806 7.83332 9.30424 8.87515 8.66793 10.3621L6.36049 6.36548Z" 
    fill="currentColor"/>
  </svg>
</template>

<script>
export default {
  name: 'ChromeIcon',
  props: {
    width: {
      type: Number,
      default: 24
    },
    height: {
      type: Number,
      default: 24
    }
  }
}
</script>

<style scoped></style>